import React from "react";
import "./AboutShikhaStyles.css";
import Shikhaa_Logo from "../../Assets/Cover/Shikhaa_Logo.png";
// import { Link } from "react-router-dom";
function AboutShikha() {
  return (
    <div className="about-container">
      <div>
        <div className="Shikha_logo_About">
          <img id="Shikha-logo" src={Shikhaa_Logo}></img>
        </div>
        {/* <h1 id="featured_Album">SHIKHAA - THE LIGHT</h1> */}
      </div>
      <h1>ABOUT SHIKHAA</h1>
      <p className="members-heading-subTitle">
        Devoted to Serve the Bangladeshi Community in US
      </p>
      <h3 className="WelcomeShikhaHeading">Welcome To Shikhaa</h3>
      <p className="aboutUs-description">
        Shikhaa – The Light is a community-driven, non-profit, non-political,
        and non-discriminatory organization (currently in the process of
        obtaining IRS 501(c)(3) tax-exempt status), based in South Florida. The
        organization is dedicated to preserving, promoting, and celebrating the
        rich language, culture, and heritage of Bangladesh within the local
        Bangladeshi community.
      </p>
      <p className="aboutUs-description">
        The name “The Light” reflects the core mission of the organization—to
        spread the cultural light of education, awareness, and identity among
        Bangladeshi families, especially the younger generation growing up
        abroad. Shikhaa aims to serve as a guiding light that connects
        individuals to their roots while fostering unity and cultural pride.
      </p>

      <p className="aboutUs-description">
        One of the key initiatives of Shikhaa – The Light is the annual Pitha
        Festival, a vibrant celebration of authentic Bangladeshi tradition and
        community spirit. This event brings together families and individuals
        through traditional food, music, recitation, and various cultural
        performances, creating an engaging and inclusive environment for all age
        groups. Through such programs, the organization provides a platform for
        cultural expression while strengthening community bonds across South
        Florida.
      </p>

      <p className="aboutUs-description">
        Beyond cultural celebrations, Shikhaa – The Light is committed to
        promoting cultural education and identity among Bangladeshi children and
        youth. By creating opportunities to experience and learn about their
        heritage, the organization works to ensure that the values, traditions,
        and spirit of Bangladesh continue to thrive in the diaspora. Shikhaa –
        The Light stands as a symbol of unity, inspiration, and cultural
        continuity for present and future generations.
      </p>

      <p className="aboutUs-description">
        We warmly invite members of the community to join us in this journey and
        help spread the light of culture, heritage, and togetherness.
      </p>

      <h3 className="WelcomeShikhaHeading">শিখা-এ স্বাগতম</h3>

      <p className="aboutUs-description">
        শিখা – দ্য লাইট (Shikhaa – The Light) একটি কমিউনিটি-ভিত্তিক, অলাভজনক,
        অরাজনৈতিক এবং বৈষম্যহীন সংগঠন (বর্তমানে IRS 501(c)(3) ট্যাক্স-এক্সেম্পট
        স্ট্যাটাস অর্জনের প্রক্রিয়ায় রয়েছে), যা দক্ষিণ ফ্লোরিডায় প্রতিষ্ঠিত।
        এই সংগঠনটি স্থানীয় বাংলাদেশি কমিউনিটির মধ্যে বাংলাদেশের সমৃদ্ধ ভাষা,
        সংস্কৃতি ও ঐতিহ্য সংরক্ষণ, প্রচার এবং উদযাপনে নিবেদিত।
      </p>

      <p className="aboutUs-description">
        “The Light” নামটি সংগঠনের মূল লক্ষ্যকে প্রতিফলিত করে—সংস্কৃতি, শিক্ষা,
        সচেতনতা এবং পরিচয়ের আলো বাংলাদেশি পরিবারগুলোর মধ্যে ছড়িয়ে দেওয়া,
        বিশেষ করে প্রবাসে বেড়ে ওঠা নতুন প্রজন্মের মধ্যে। শিখা এমন একটি
        পথপ্রদর্শক আলোর মতো কাজ করতে চায়, যা মানুষকে তাদের শিকড়ের সাথে সংযুক্ত
        করে এবং ঐক্য ও সাংস্কৃতিক গর্বকে আরও শক্তিশালী করে।
      </p>

      <p className="aboutUs-description">
        শিখা – দ্য লাইট-এর অন্যতম প্রধান উদ্যোগ হলো বার্ষিক পিঠা উৎসব, যা
        বাংলাদেশের ঐতিহ্য, সংস্কৃতি এবং কমিউনিটির চেতনাকে উদযাপন করে একটি
        প্রাণবন্ত আয়োজন। এই অনুষ্ঠানে ঐতিহ্যবাহী খাবার, সংগীত, আবৃত্তি এবং
        বিভিন্ন সাংস্কৃতিক পরিবেশনার মাধ্যমে পরিবার ও কমিউনিটির সদস্যরা একত্রিত
        হয়। এ ধরনের কার্যক্রমের মাধ্যমে সংগঠনটি সাংস্কৃতিক প্রকাশের একটি
        প্ল্যাটফর্ম তৈরি করে এবং দক্ষিণ ফ্লোরিডা জুড়ে কমিউনিটির বন্ধনকে আরও
        দৃঢ় করে।
      </p>

      <p className="aboutUs-description">
        শুধুমাত্র সাংস্কৃতিক উদযাপনের মধ্যেই সীমাবদ্ধ না থেকে, শিখা – দ্য লাইট
        বাংলাদেশি শিশু ও তরুণদের মধ্যে সাংস্কৃতিক শিক্ষা এবং পরিচয় গড়ে তুলতে
        প্রতিশ্রুতিবদ্ধ। তাদের ঐতিহ্য সম্পর্কে জানার এবং অনুভব করার সুযোগ তৈরি
        করে এই সংগঠনটি নিশ্চিত করতে চায় যে বাংলাদেশের মূল্যবোধ, সংস্কৃতি ও
        চেতনা প্রবাসেও সমানভাবে বিকশিত হয়। শিখা – দ্য লাইট বর্তমান ও ভবিষ্যৎ
        প্রজন্মের জন্য ঐক্য, অনুপ্রেরণা এবং সাংস্কৃতিক ধারাবাহিকতার প্রতীক।
      </p>

      <p className="aboutUs-description">
        আমরা আন্তরিকভাবে কমিউনিটির সকল সদস্যকে এই যাত্রায় আমাদের সাথে যুক্ত
        হওয়ার আহ্বান জানাই এবং সংস্কৃতি, ঐতিহ্য ও একতার আলো ছড়িয়ে দিতে সবাইকে
        এগিয়ে আসার আমন্ত্রণ জানাই।
      </p>
    </div>
  );
}

export default AboutShikha;
